export default "<span class=\"utah-gov-logo__vert-line\"></span>";